const translationHu = {
  "frontpage-hero-h1": "Fizetési<br />szolgáltatások<br />mindenkinek",
};

export default translationHu;
